import React from 'react'

export const NotificationBanner = ({ children }) =>
  <section className="notification-banner flex-col md:flex-row">
    {children}
  </section>

export const NotificationBannerMessage = ({ ...props }) =>
  <div className={`notification-banner__message ` + (props.className ? props.className : '')}>
    <p>
      {props.text}
    </p>
  </div>

export const NotificationBannerAction = ({ ...props }) =>
  <div className={`notification-banner__action ` + (props.className ? props.className : '')}>
    <a href={props.path} className={"button button--primary"}>
      {props.text}
    </a>
  </div>
